// var url= 'sale4all.co.il';
// The host MUST match the host the Angular app is served from, or the
// refresh cookie is dead on arrival. It is set SameSite=Strict
// (utils/refresh_cookie.py), so the browser only attaches it to
// SAME-SITE requests. Serving the app on localhost:4200 while calling
// an API on 192.168.1.144:8000 is CROSS-site, so the cookie was never
// sent, every /api/auth/token/refresh/ returned 401, and the app logged
// itself out on the first 401 and on every full page load (the access
// token is deliberately memory-only, so a reload must refresh).
//
// Ports are irrelevant to SameSite - only the host is compared - so
// localhost:4200 -> localhost:8000 is same-site and the cookie flows.
// Use 'localhost', NOT '127.0.0.1': those are different hosts to the
// SameSite check, so 127.0.0.1 would break it again.
// For LAN/device testing you need HTTPS + REFRESH_COOKIE_SAMESITE=None.

import { API_CONFIG } from './api-config';

// One build works on every environment: the API is api.<the site this app is
// served from>, read in the browser at runtime.
//   sale4all.co.il, www.sale4all.co.il, admin.sale4all.co.il -> api.sale4all.co.il
//   dev.sale4all.co.il, admin.dev.sale4all.co.il             -> api.dev.sale4all.co.il
//   (a future stg./qa. environment works the same way, no code change)
// Anything else - localhost, a LAN IP, or server-side rendering where there is
// no window - falls back to ./api-config.ts (written by Jenkins per branch,
// your local value otherwise).
function apiFromPageHost(): string | null {
  if (typeof window === 'undefined' || !window.location) { return null; }
  const site = window.location.hostname.toLowerCase().replace(/^(www|admin)\./, '');
  return /(^|\.)sale4all\.co\.il$/.test(site) ? `https://api.${site}` : null;
}

const PAGE_API = apiFromPageHost();

export const SystemApp = {
  base_url: PAGE_API ? `${PAGE_API}/` : API_CONFIG.baseUrl,
  base_url_api: PAGE_API ?? API_CONFIG.apiUrl,
  web_socket: PAGE_API ? `${PAGE_API.replace(/^https:/, 'wss:')}/ws/` : API_CONFIG.wsUrl,
};
